import React from "react"
import {BankLogoProps, defaultBankLogoSize} from "./bankLogoUtils"

export function PiermontBankLogo({size = defaultBankLogoSize, fill, className}: BankLogoProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 28 28"
			className={className}
		>
			<path fill={fill} d="M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14Z" />
			<path fill="#171717" fillRule="evenodd" d="M20 12h-4v4.25h-4v4h8V12Z" clipRule="evenodd" />
			<path fill="#171717" fillRule="evenodd" d="M8 16.25h4V12h4V8H8v8.25Z" clipRule="evenodd" />
		</svg>
	)
}
